import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { maxImageSize, allowedImagesFormats } from 'constants/validation'
import FormIamge from './FormImage'

const getBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

const FormImageContainer = ({ onChange, field, isMultiple }) => {
  const translataions = {
    description: 'Drag here to upload your attachment.',
    description2: 'Allowed up to 2MB PNG,  JPG, JPEG.',
    removeAll: 'remove all',
  }
  const [selectedImage, setSelectedImage] = useState(null)
  const [selectedImages, setSelctedImages] = useState([])
  const [error, setError] = useState(null)

  const onDrop = useCallback(
    acceptedFiles => {
      const image = acceptedFiles[0]

      if (image) {
        setError(null)
        getBase64(image).then(base64Image => {
          onChange(base64Image)
          setSelectedImage(image)
        })
      }
      setSelctedImages([...selectedImages, ...acceptedFiles])
    },
    [selectedImages]
  )

  const onRemoveImage = useCallback(
    image => {
      const newAttachedImages = [...selectedImages]
      newAttachedImages.splice(newAttachedImages.indexOf(image), 1)
      setSelctedImages([...newAttachedImages])
      onChange('')
    },
    [selectedImages]
  )

  const onRemoveAll = useCallback(() => {
    setSelctedImages([])
    setError(null)
    onChange('')
  }, [selectedImages])

  const onDropRejected = useCallback(files => {
    const file = files[0]
    if (file.size > maxImageSize) {
      setError('The file size must be less than 2MB')
      return
    }
    if (allowedImagesFormats.indexOf(file.type)) {
      setError('Choose image in allowed format (png, jpeg, jpg)')
      return
    }
    setError('Please choose another file')
  }, [])

  const isRemoveAllActive = useMemo(() => selectedImages?.length > 1, [
    selectedImages,
  ])

  const isSelectedImagesActive = useMemo(() => selectedImages?.length > 0, [
    selectedImages,
  ])

  useEffect(() => {
    if (!field.value && selectedImages?.length > 0) {
      onRemoveAll()
    }
  }, [field.value])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    onDropRejected,
    accept: allowedImagesFormats,
    maxSize: maxImageSize,
    multiple: !!isMultiple,
  })

  const props = {
    field,
    error,
    selectedImage,
    selectedImages,
    isSelectedImagesActive,
    translataions,
    isDragActive,
    isRemoveAllActive,
    onRemoveImage,
    getRootProps,
    getInputProps,
    onRemoveAll,
    isMultiple,
  }

  return <FormIamge {...props} />
}

export default FormImageContainer
